import { KEYS } from '../../../../../../../../l18n/constants';
import computeClassName from '../../../../../../../../utils/computeClassName';
import { useL18nContext } from '../../../../../../ContextProvider/L18n';
import { usePartnerSearchContext } from '../../../../../../ContextProvider/Partner/Search';
import FormTabsTab from './Tab';
import CCIconSearch16x16 from '../../../../../../../libs/CiscoCore/Icon/Search/16x16';

const constants = Object.freeze({
  CLASSNAME_BASE: '-mt-cc-13 sm:-mt-14 text-cc-body-medium sm:text-cc-body-large'
});

export default function FormTabs({className}) {
  const { getTranslationFor } = useL18nContext();
  const translatedLabelFilterByNeed = getTranslationFor(KEYS.L18N_KEY_LABEL_FILTER_BY_NEED);
  const translatedLabelSearch = getTranslationFor(KEYS.L18N_KEY_LABEL_SEARCH);
  const translatedLabelByNameLevelExpertise = getTranslationFor(KEYS.L18N_KEY_LABEL_BY_NAME_ONE_LEVEL_AND_EXPERTISE);
  const {
    selectFilterByNeedForm,
    selectSearchByCombinedCriteriaForm,
    isFilterByNeedFormSelected,
    isSearchByCombinedCriteriaFormSelected,
    isSearchByLocationFormSelected
  } = usePartnerSearchContext();

  const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);
  return (
    <nav className={computedClassName}>
      {
        isSearchByLocationFormSelected() ?

          <></> :

          <ul className="list-none flex flex-row items-center">
            <FormTabsTab isSelected={isFilterByNeedFormSelected()}
                         isFirst={true}
                         selectFn={selectFilterByNeedForm}>{translatedLabelFilterByNeed}</FormTabsTab>
            <FormTabsTab isSelected={isSearchByCombinedCriteriaFormSelected()}
                         selectFn={selectSearchByCombinedCriteriaForm}
                         className="flex-grow">
              <span className="flex items-center">
                <span className="flex items-center"><CCIconSearch16x16/><span className="ml-2.5 mr-cc-1char">{translatedLabelSearch}</span></span><span className="hidden xs:inline-block">{translatedLabelByNameLevelExpertise}</span>
              </span>
            </FormTabsTab>
          </ul>
      }
    </nav>
  );
}

